<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'dashboard.remove.label' | translate }}</label>
    <label class="ec-radio-label">
      <input appInput type="radio" formControlName="response" [value]="UserResponse.Approved"> {{ 'dashboard.remove.approve' | translate }}
    </label>
    <label class="ec-radio-label">
      <input appInput type="radio" formControlName="response" [value]="UserResponse.Rejected"> {{ 'dashboard.remove.deny' | translate }}
    </label>
  </app-input-group>
</form>
